import { IncomingMessage } from 'http';

import { QueryFunction, QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import fetchLastEntries from '../../../services/products/last-entries';
import { getLastEntriesKey } from '../query-keys';

const getLasEntries = (
  options: {
    locale: string;
    part?: string;
    vehicle?: string;
    detailed_prices: boolean;
    category?: string;
    page?: 'home' | 'catalogue' | 'brands';
  },
  req?: IncomingMessage
): [QueryKey, QueryFunction<ReturnType<typeof fetchLastEntries>>] => {
  return [
    getLastEntriesKey(options),
    ({
      queryKey: [, locale, part, vehicle, detailed_prices, category, page],
    }: QueryFunctionContext<string[], any>): Promise<any> =>
      fetchLastEntries(
        {
          locale,
          ...(vehicle && { carIdentifier: vehicle }),
          detailed_prices: detailed_prices,
          ...(part && { partIdentifier: part }),
          ...(category && { categoryIdentifier: category }),
          ...(page && { pageIdentifier: page }),
        },
        req
      ),
  ];
};

export default getLasEntries;
